import { action, makeObservable, observable } from "mobx";
import { BaseModel } from "../../../../../../../../core/util/BaseModel";
import ProjectProcessesApi, {
  ProjectProcessesApi as IProjectProcessesApi
} from "../../../../../../../../services/api/v2/projectProcesses/ProjectProcesses.api";

export class StakeholderOwnersSidebarModel extends BaseModel {
  projectProcessProvider: IProjectProcessesApi;
  @observable isLoading: boolean = true;
  @observable isSearchMode: boolean = false;
  @observable.ref projectStakeholders: FP.Entities.IProjectStakeholder[];
  @observable searchValue: string = "";
  organisationId: number;
  projectId: number;
  closeModalFn: () => void;
  projectProcessId: number;

  constructor(closeModalFn: () => void, organisationId: number, projectId: number, projectProcessId: number) {
    super();
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.projectProcessProvider = ProjectProcessesApi;
    this.isLoading = true;
    this.projectProcessId = projectProcessId;
    this.closeModalFn = closeModalFn;
  }

  onMount = () => {
    this.loadProjectStakeholders(this.projectProcessId);
  };

  onUnmount = () => {
    this.resetSearch();
  };

  @action
  resetSearch = () => {
    this.searchValue = "";
    this.hideSearchMode();
  };

  @action
  hideSearchMode = () => {
    this.isSearchMode = false;
  };

  @action
  showSearchMode = () => {
    this.isSearchMode = true;
  };

  @action
  setProjectStakeholders = (stakeholders: FP.Entities.IProjectStakeholder[]) =>
    (this.projectStakeholders = stakeholders);

  @action
  loadProjectStakeholders = async (projectProcessId: number) => {
    let res = await this.projectProcessProvider.getStakeholderOwnersByProjectProcessId(
      this.organisationId,
      this.projectId,
      projectProcessId
    );
    if (!res || res.isError) return;

    this.setProjectStakeholders(res.payload);
    this.isLoading = false;
  };

  removeProjectStakeholder = async (stakeholderId: number) => {
    let res = await this.projectProcessProvider.removeProjectProcessStakeholderOwner(
      this.organisationId,
      this.projectId,
      this.projectProcessId,
      stakeholderId
    );
    if (!res || res.isError) return;

    this.loadProjectStakeholders(this.projectProcessId);
  };
}
